import * as React from "react";
import { CurrentRouteContext } from "src/modules/Routing/auth/CurrentRouteContext";

export const useCurrentRoute = () => {
  return React.useContext(CurrentRouteContext)
}


// WEBPACK FOOTER //
// ./src/modules/Routing/auth/useCurrentRoute.tsx